export default __webpack_public_path__ + "static/media/ilian_m.a368c098.jpg";